import { createAsyncThunk } from '@reduxjs/toolkit';
import createApiFromState from 'api/createApiFromState';

const datasetVersionPublish = createAsyncThunk(
  'dataset-version/publish',
  async ({ versionId }, { dispatch, getState }) => {
    const api = createApiFromState({ dispatch, getState });
    const response = await api.post(
      `/api/dataset-versions/${versionId}/publish`,
      {},
    );
    return response.data;
  },
);

export { datasetVersionPublish };
